var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{class:[_vm.cardClass, 'wml-modern-card'],attrs:{"color":"card","elevation":_vm.elevation}},[_c('v-card-text',{staticClass:"pa-0",on:{"click":_vm.click}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }